import React from 'react';
import { useTranslation } from 'react-i18next';
import marqueeConfig from '../../config/restoPhotoMarquee.json';

const TILTS = ['-2deg', '1.5deg', '-1deg', '2deg', '-1.5deg'];

export const RestoPhotoMarquee: React.FC = () => {
  const { i18n } = useTranslation();
  const rtl = typeof i18n.dir === 'function' && i18n.dir(i18n.language) === 'rtl';
  const photos = marqueeConfig.photos;
  const loop = [...photos, ...photos];

  return (
    <div className="km-photo-marquee relative overflow-hidden py-6" aria-hidden="true">
      <div
        className={`km-photo-marquee-track flex w-max gap-6 ${rtl ? 'km-photo-marquee-rtl' : ''}`}
        style={{ animationDuration: `${marqueeConfig.durationSeconds}s` }}
      >
        {loop.map((photo, index) => (
          <div
            key={`${photo.src}-${index}`}
            className="km-photo-marquee-card group relative h-56 w-80 shrink-0 overflow-hidden rounded-3xl shadow-xl ring-4 ring-komby-yellow/0 transition duration-500 hover:ring-komby-yellow md:h-64 md:w-96"
            style={{ ['--km-tilt' as string]: TILTS[index % TILTS.length] }}
          >
            <img
              src={photo.src}
              srcSet={`${photo.mobile} ${marqueeConfig.mobileWidth}w, ${photo.src} ${photo.width}w`}
              sizes={marqueeConfig.sizes}
              alt=""
              className="km-photo-marquee-img h-full w-full object-cover"
              style={{ animationDelay: `${-(index % photos.length) * 4}s` }}
              loading="lazy"
              decoding="async"
              width={photo.width}
              height={photo.height}
            />
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent transition-opacity duration-500 group-hover:opacity-0" />
          </div>
        ))}
      </div>
    </div>
  );
};
